import React from 'react';
import { observer } from 'mobx-react-lite';

import Checkbox from 'widget/shared/ui/Checkbox';
import Typography, {
  TypographySize,
  TypographyColor,
  TypographyWeight
} from 'widget/shared/ui/Typography';
import { TypographyTag } from 'widget/shared/ui/Typography/types';
import { ExternalLink } from 'widget/shared/ui/ExternalLink';
import { FormConsentField } from 'widget/types/submissionFormState';
import { WidgetConsentsType } from 'widget/entities/config';

import styles from './ConsentsItem.module.scss';

type Props = {
  consent: FormConsentField;
  isChecked: boolean;
  onChange?: (type: WidgetConsentsType, checked: boolean) => void;
  linkText: string;
  label?: string;
  disabled: boolean;
  className?: string;
};

const ConsentsItem: React.FC<Props> = ({
  consent,
  isChecked,
  onChange,
  disabled,
  linkText,
  label,
  className
}) => {
  const handleChange = React.useCallback(
    (checked: boolean) => {
      onChange && onChange(consent.type, checked);
    },
    [onChange, consent.type]
  );
  return (
    <div className={className}>
      <Checkbox
        key={consent.type}
        checked={isChecked}
        onChange={handleChange}
        disabled={disabled}
      >
        <Typography
          tag={TypographyTag.span}
          size={TypographySize.s}
          color={TypographyColor.secondary}
          weight={TypographyWeight.normal}
        >
          {consent.docUrl ? (
            <ExternalLink
              href={consent.docUrl}
              linkText={linkText}
              text={label}
            />
          ) : (
            label
          )}
          {consent.required && (
            <span className={styles['consents-item__required']}> *</span>
          )}
        </Typography>
      </Checkbox>
    </div>
  );
};

export default observer(ConsentsItem);
